import React from 'react';

const TestimonialIcon = () => {
      return (
            <>
                  <span className="material-symbols-outlined">quiz</span>
            </>
      );
};

export default TestimonialIcon;
